// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__en5IP","brandName":"Footer_brandName__3D-ZN"};